module.exports = __webpack_public_path__ + "img/hoavang.7df08b54.jpg";